document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-story-cards]');

  sections.forEach((section) => {
    const track = section.querySelector('[data-story-track]');
    if (!track) return;

    const cards = Array.from(section.querySelectorAll('[data-story-card]'));
    const prevBtn = section.querySelector('[data-story-prev]');
    const nextBtn = section.querySelector('[data-story-next]');
    const progressBars = Array.from(section.querySelectorAll('[data-story-progress] > *'));
    const counter = section.querySelector('[data-story-counter]');

    if (cards.length === 0) return;

    const swipeLabel = section.dataset.swipeLabel || 'SWIPE';
    let currentIndex = 0;
    let autoAdvanced = false;
    let autoAdvanceTimer = null;
    let isAnimating = false;

    const setClasses = (exitingIndex = -1) => {
      const isLast = currentIndex === cards.length - 1;

      cards.forEach((card, i) => {
        card.classList.remove('is-active', 'is-peek', 'is-inactive', 'is-exiting');
        card.style.order = '';

        if (i === exitingIndex) {
          // Card leaving the peek slot: keep its position (order 2) so it
          // collapses in place instead of teleporting to the start of the track.
          card.classList.add('is-exiting');
          card.style.order = '2';
        } else if (i === currentIndex) {
          card.classList.add('is-active');
          card.style.order = isLast ? '2' : '1';
        } else if (isLast && i === currentIndex - 1) {
          card.classList.add('is-peek');
          card.style.order = '1';
        } else if (!isLast && i === currentIndex + 1) {
          card.classList.add('is-peek');
          card.style.order = '2';
        } else {
          card.classList.add('is-inactive');
          card.style.order = '0';
        }
      });
    };

    const updateUI = () => {
      if (counter) {
        counter.textContent = `${currentIndex + 1} / ${cards.length} · ${swipeLabel}`;
      }
      progressBars.forEach((bar, i) => {
        bar.classList.toggle('is-active', i === currentIndex);
      });
    };

    const goTo = (index) => {
      if (isAnimating) return;
      isAnimating = true;
      const direction = index < currentIndex ? 'back' : 'fwd';
      const wasLast = currentIndex === cards.length - 1;
      // Going back from a non-last state: the right-side peek card becomes
      // inactive. Let it exit in place (mirrors the forward animation).
      const exitingIndex = direction === 'back' && !wasLast ? currentIndex + 1 : -1;
      currentIndex = Math.max(0, Math.min(index, cards.length - 1));
      cards.forEach((card) => card.classList.add('is-animating'));
      setClasses(exitingIndex);
      updateUI();
      setTimeout(() => {
        if (exitingIndex >= 0) {
          const exitingCard = cards[exitingIndex];
          exitingCard.classList.remove('is-exiting');
          exitingCard.classList.add('is-inactive');
          exitingCard.style.order = '';
        }
        isAnimating = false;
        cards.forEach((card) => card.classList.remove('is-animating'));
      }, 550);
    };

    const next = () => {
      cancelAutoAdvance();
      goTo(currentIndex + 1);
    };

    const prev = () => {
      cancelAutoAdvance();
      goTo(currentIndex - 1);
    };

    const cancelAutoAdvance = () => {
      if (autoAdvanceTimer) {
        clearTimeout(autoAdvanceTimer);
        autoAdvanceTimer = null;
      }
      autoAdvanced = true;
    };

    const autoAdvance = () => {
      if (autoAdvanced || cards.length <= 1) return;
      autoAdvanced = true;
      goTo(1);
    };

    prevBtn?.addEventListener('click', prev);
    nextBtn?.addEventListener('click', next);

    // Tap on a peek card to advance/previous; tap on active does nothing.
    track.addEventListener('click', (event) => {
      const card = event.target.closest('[data-story-card]');
      if (!card || isAnimating) return;
      if (card.classList.contains('is-peek')) {
        if (currentIndex === cards.length - 1) {
          prev();
        } else {
          next();
        }
      }
    });

    // Swipe support
    let touchStartX = 0;
    let touchEndX = 0;

    track.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0].screenX;
      cancelAutoAdvance();
    }, { passive: true });

    track.addEventListener('touchend', (event) => {
      touchEndX = event.changedTouches[0].screenX;
      const delta = touchStartX - touchEndX;
      if (Math.abs(delta) > 40) {
        if (delta > 0) next();
        else prev();
      }
    }, { passive: true });

    ['mousedown', 'pointerdown', 'wheel'].forEach((evt) => {
      track.addEventListener(evt, cancelAutoAdvance, { passive: true });
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !autoAdvanced && !autoAdvanceTimer) {
          autoAdvanceTimer = setTimeout(autoAdvance, 3000);
          observer.disconnect();
        }
      });
    }, { threshold: 0.3 });

    observer.observe(section);

    setClasses();
    updateUI();
  });
});
